module.exports = __webpack_public_path__ + "img/productRobot_14.2999c88e.png";